import { Box, Stack, Typography } from "@mui/material"
import Section from "./Section"

export interface DetailsProps {
  phone: boolean
}

export default function Details({ phone }: DetailsProps) {
  return (
    <Section>
      <Stack
        direction={phone ? "column" : "row"}
        justifyContent="center"
        alignItems="center"
        spacing={5}
        width="100%"
      >
        <Box
          component="img"
          src="/tech.jpg"
          width="100%"
          maxWidth="420px"
          sx={{
            borderRadius: 2,
            overflowY: "hidden",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.5)",
          }}
        />

        <Stack
          maxWidth={420}
          textAlign="start"
          spacing={2}
          sx={{ pl: 1, pr: 2 }}
        >
          <Typography
            variant="body1"
            color={"rgb(154, 167, 180)"}
            fontSize="large"
          >
            L’organisation d’un entrepôt est un système complexe, difficile à
            optimiser en utilisant des outils artisanaux basés sur la méthode
            ABC.
          </Typography>
          <Typography
            variant="body1"
            color={"rgb(154, 167, 180)"}
            fontSize="large"
          >
            WM-up vous permet de rationaliser la gestion de vos entrepôts grâce
            à un logiciel spécifique exploitant des algorithmes issus de la
            recherche scientifique.
          </Typography>
          <Typography
            variant="body1"
            color={"rgb(154, 167, 180)"}
            fontSize="large"
          >
            WM-up vous propose des actions correctives dont l’impact est
            finement quantifié.
          </Typography>
        </Stack>
      </Stack>
    </Section>
  )
}
